export default [
  // { title: "Send Money", icon: "ri-home-4-line", link: "/send-money" },
  { title: "Single Disbursement", icon: "ri-hom-4-line", link: "/disbursement" },
  { title: "Bulk Disbursement", icon: "ri-hom-4-line", link: "/bulk-disbursement" },
  { title: "Scheduled Disbursement", icon: "ri-hom-4-line", link: "/schedule-disbursement" },
  // { title: "Transaction History", icon: "ri-file-edit-line", link: "/history-money" },
];
